import { useState } from "react";
import axios from "../../../axios";
import { mediaUrl } from "../common";
import { useSharedState } from "../answers";
import * as s from "./kids.styled";
import Celebrate from "./Celebrate";

// Блоки дитячих курсів (пробний урок es-kids-trial, 2026-10).

// Жовта лампочка з промінцями — як на «About us» старого пробного
const Bulb = () => (
  <svg viewBox="0 0 120 130" aria-hidden="true">
    <g stroke="#2B2D7C" strokeWidth="4" strokeLinecap="round">
      <path d="M60 6v12M22 22l9 9M98 22l-9 9M6 58h12M102 58h12M18 92l9-6M102 92l-9-6" />
    </g>
    <path d="M60 26c-19 0-33 14-33 32 0 12 6 20 13 27 4 4 6 8 6 13h28c0-5 2-9 6-13 7-7 13-15 13-27 0-18-14-32-33-32z" fill="#FCE77D" />
    <path d="M52 98V78c0-4-6-4-6 0s6 6 14 6 14-2 14-6-6-4-6 0v20" fill="none" stroke="#2B2D7C" strokeWidth="3.5" strokeLinecap="round" />
    <rect x="44" y="98" width="32" height="20" rx="8" fill="#C5DDE0" />
  </svg>
);

// ---------- about: «Про нас» — тепла картка з текстом, як «About us» у старому пробному ----------
// data.lines = [{ lead: "Ми", text: "— онлайн-школа…" }] — lead виділяється кольором
function About({ slide }) {
  const { lines = [] } = slide.data || {};
  return (
    <s.About>
      <s.AboutMascot>
        <Bulb />
      </s.AboutMascot>
      <s.AboutCard>
        {lines.map((line) => (
          <p key={line.text}>
            {line.lead && <em>{line.lead} </em>}
            {line.text}
          </p>
        ))}
      </s.AboutCard>
    </s.About>
  );
}

// ---------- rating: «Як тобі урок?» — 1–5 зірок; герой реагує: 4–5 радіє й дякує, 1–2 сумує, 3 — просто «дякую» ----------
// data.happy / data.sad = { image, audio, text } (Coco «¡Gracias!» / «Oh…»); data.other — підпис для 3 зірок.
// Оцінка йде в аналітику уроку (POST /platform-lessons/:id/rating; без привʼязки до учня) — адмін бачить ★ у списку уроків
function Rating({ slide, lesson }) {
  // data.celebrate — за 4–5 зірок конфеті й фанфара (як на підсумку дитячих уроків)
  const { happy = {}, sad = {}, other = "¡Gracias!", celebrate } = slide.data || {};
  const [picked, setPicked] = useSharedState(slide.id, "picked", 0);
  const [hover, setHover] = useState(0);

  const pick = (n) => {
    setPicked(n);
    const hero = n >= 4 ? happy : n <= 2 ? sad : null;
    if (hero?.audio?.url) new Audio(mediaUrl(hero.audio.url, hero.audio)).play().catch(() => {});
    if (lesson?.lessonId) axios.post(`platform-lessons/${lesson.lessonId}/rating`, { stars: n }).catch(() => {});
  };

  const lit = hover || picked;
  const mood = picked >= 4 ? happy : picked && picked <= 2 ? sad : null;
  const hero = mood && (mood.image || mood.text) ? mood : null; // без героя (уроки для дорослих) — лише підпис other
  return (
    <s.Rating>
      {celebrate && picked >= 4 && <Celebrate key={picked} />}
      <s.Stars onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((n) => (
          <s.Star key={n} type="button" $on={n <= lit} onMouseEnter={() => setHover(n)} onClick={() => pick(n)} aria-label={`${n}`}>
            ★
          </s.Star>
        ))}
      </s.Stars>
      {hero && (
        <s.Thanks key={picked >= 4 ? "happy" : "sad"}>
          {hero.image && <img src={mediaUrl(hero.image)} alt="" />}
          <s.Bubble $sad={picked <= 2}>{hero.text || "¡Gracias!"}</s.Bubble>
        </s.Thanks>
      )}
      {picked > 0 && !hero && <s.Small>{other}</s.Small>}
    </s.Rating>
  );
}

export const KIDS_BLOCKS = {
  about: About,
  rating: Rating,
};
